/** @format */

import axios from "axios";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_HistoryAcademic;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listar: async (codigo, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINT}${codigo}`, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(Constantes().msmAcademico, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.programArray.length == 0) {
        getAlert(Constantes().msmAcademico, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
};

export default API;
